// @ts-ignore - this makes tsc happy
import env from "configs/env"

// Define the type for the clarity function
interface Clarity {
   (...args: any[]): void
   q?: any[]
}

// Ensure window.clarity is typed correctly
declare global {
   interface Window {
      clarity: Clarity
   }
}

const initMicrosoftClarity = () => {
   if (env.TARGET_ENV === "development") return // Show Microsoft Clarity in production & stage only

   // Initialize clarity function if it doesn't exist
   window.clarity =
      window.clarity ||
      function (...args: any[]) {
         ;(window.clarity.q = window.clarity.q || []).push(args)
      }

   // Add Microsoft Clarity script
   const script = document.createElement("script")
   script.src = "https://www.clarity.ms/tag/smmj5ceg2u"
   script.async = true
   script.type = "text/javascript"

   script.onload = () => {
      console.log("Microsoft Clarity loaded successfully.")
   }

   // Insert the script into the document
   const firstScript = document.getElementsByTagName("script")[0]
   if (firstScript && firstScript.parentNode) {
      firstScript.parentNode.insertBefore(script, firstScript)
   } else {
      document.head.appendChild(script)
   }
}

export default initMicrosoftClarity
